__turbopack_context__.v({
  "border": "Button-module-scss-module__JsLnKG__border",
  "error": "Button-module-scss-module__JsLnKG__error",
  "fill": "Button-module-scss-module__JsLnKG__fill",
  "large": "Button-module-scss-module__JsLnKG__large",
  "light": "Button-module-scss-module__JsLnKG__light",
  "link": "Button-module-scss-module__JsLnKG__link",
  "medium": "Button-module-scss-module__JsLnKG__medium",
  "neutral": "Button-module-scss-module__JsLnKG__neutral",
  "primary": "Button-module-scss-module__JsLnKG__primary",
  "root": "Button-module-scss-module__JsLnKG__root",
  "secondary": "Button-module-scss-module__JsLnKG__secondary",
  "small": "Button-module-scss-module__JsLnKG__small",
  "success": "Button-module-scss-module__JsLnKG__success",
  "underline": "Button-module-scss-module__JsLnKG__underline",
  "warning": "Button-module-scss-module__JsLnKG__warning",
  "xl": "Button-module-scss-module__JsLnKG__xl",
  "xs": "Button-module-scss-module__JsLnKG__xs",
  "xxl": "Button-module-scss-module__JsLnKG__xxl",
  "xxs": "Button-module-scss-module__JsLnKG__xxs",
});
